import {
  getRequest,
  postFormData,
  postRequest,
  putFormData,
  putRequest,
} from '.'

export const getTeamApplications = async (
  id: number,
  pendingOnly = false,
): Promise<wowaudit.TeamApplication[]> => {
  return await getRequest(
    `/api/teams/${id}/applications${pendingOnly ? '?show_pending=true' : ''}`,
  )
}

export const getUserApplications = async (
  pendingOnly = false,
): Promise<wowaudit.UserApplication[]> => {
  return await getRequest(
    `/api/user/applications${pendingOnly ? '?show_pending=true' : ''}`,
  )
}

export const getUserApplicationSummary = async (): Promise<
  Record<string, number>
> => {
  return await getRequest(`/api/user/applications/summary`)
}

export const getTeamApplicationDetails = async (
  teamId: number,
  id: number,
): Promise<wowaudit.ApplicationDetails> => {
  return await getRequest(`/api/teams/${teamId}/applications/${id}`)
}

export const getUserApplicationDetails = async (
  id: number,
): Promise<wowaudit.ApplicationDetails> => {
  return await getRequest(`/api/user/applications/${id}`)
}

export const getApplicationMessages = async (
  teamId: number,
  id: number,
  type: 'messages' | 'notes',
): Promise<wowaudit.ApplicationMessage[]> => {
  return await getRequest(
    `/api/teams/${teamId}/applications/${id}/messages?type=${type}`,
  )
}

export const updateApplication = async <T extends wowaudit.Application>(
  teamId: number | undefined,
  id: number,
  data: Partial<T> & { message?: string },
  author: 'user' | 'team',
): Promise<T> => {
  return author === 'team'
    ? putRequest(`/api/teams/${teamId}/applications/${id}`, data)
    : putRequest(`/api/user/applications/${id}`, data)
}

export const createApplicationMessage = async (
  teamId: number,
  id: number,
  message: string,
  internal: boolean,
): Promise<wowaudit.ApplicationMessage> => {
  return await postRequest(`/api/teams/${teamId}/applications/${id}/messages`, {
    message,
    internal,
  })
}

export const createApplication = async (
  formData: FormData,
): Promise<wowaudit.Application> => {
  return await postFormData(`/api/user/applications`, formData)
}

export const updateApplicationWithFormData = async (
  id: number,
  formData: FormData,
): Promise<wowaudit.Application> => {
  return await putFormData(`/api/user/applications/${id}`, formData)
}
